import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import {
  InformationItemContainer,
  NoteDeleteButton,
  InformationItemInputsContainer,
  PhoneInput,
  WarningsDisplay,
} from '../../../../../../layout';
import phoneStyle from './style';
// Types
import { NewAddress } from '../../../../../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';
import { useEditEntity } from '../../../../../../../../../../../context/EditEntityContext';

type Props = {
  data: NewAddress | IContactAddress;
};

const Phone = ({ data }: Props) => {
  const mode = 'edit';
  const { editEntity } = useEditEntity();
  const editEntityActions = editEntity.action;
  const editEntityState = editEntity.state;
  const [warnings, setWarnings] = useState<string[]>([]);
  const [checked, setChecked] = useState(true);

  useEffect(() => {
    setChecked(warnings.length === 0 && (data.address ?? '') !== '');
  }, [warnings, data.address]);

  return (
    <InformationItemContainer>
      <InformationItemInputsContainer>
        <Box sx={{ ...phoneStyle.numberCountryContainer, flexDirection: 'column' }}>
          <PhoneInput
            data={data}
            setWarnings={setWarnings}
            onChange={editEntityActions.handleAddressFieldChange}
          />
          {warnings.length > 0 && <WarningsDisplay warnings={warnings} />}
        </Box>
        <NoteDeleteButton
          mode={mode}
          addressData={data}
          handleNoteFieldChange={editEntityActions.handleNoteFieldChange}
          handleDeleteAddress={editEntityActions.handleDeleteAddress}
          isDeletingAddress={editEntityState.isDeletingAddress}
          replaceAddress={editEntityActions.replaceAddress}
          addWhatsappVerified={(editEntityActions as any).addWhatsappVerified}
          checked={checked}
        />
      </InformationItemInputsContainer>
    </InformationItemContainer>
  );
};

export default Phone;
